import { render, staticRenderFns } from "./TeacherDashboard.vue?vue&type=template&id=8dc0a76c&scoped=true&"
import script from "./TeacherDashboard.vue?vue&type=script&lang=js&"
export * from "./TeacherDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDashboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeacherDashboard.vue?vue&type=style&index=1&id=8dc0a76c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc0a76c",
  null
  
)

export default component.exports